'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('TechElementCtrl', TechElementCtrl);

  TechElementCtrl.$inject = ['$scope', 'TechnicalElementsAPI', 'constants',
    'technicalElements', '$log', 'Labels', '$mdDialog',
    'SimpleDialogFormService', 'TechElementModuleService', 'TechElementSubmoduleService'];

  function TechElementCtrl ($scope, TechnicalElementsAPI, constants,
    technicalElements, $log, Labels, $mdDialog,
    SimpleDialogFormService, TechElementModuleService, TechElementSubmoduleService) {

    $scope.elementTypes = constants.ELEMENT_TYPES;
    $scope.elementUnits = constants.UNIT_TYPES;
    $scope.LABELS = Labels;
    $scope.modules = technicalElements;
    $scope.model = {
      techElementOptions: [{
        name: Labels.getPlural('edit'),
        icon: 'edit',
        action: 'editTechElement'
      }]
    };

    // element / (sub)module item actions
    $scope.doItemActionFor = function (event, item, action, moduleId, submoduleId) {
      switch (action) {
        case 'editTechElement':
          item.module = {_id: moduleId};
          item.submodule = {_id: submoduleId};
          openTechElementModal(event, item);
          break;
        case 'remove':
          removeTechElement(item._id, moduleId, submoduleId);
          break;
      }
    };

    function setUnitsAndTypes () {
      // set elementUnits and elementTypes
      $scope.modules.forEach(function (techModule) {
        techModule.submodules.forEach(function (techSubModule) {
          techSubModule.elements.forEach(function (techElement) {
            const unit = $scope.elementUnits.find((value) => value.value === techElement.unit);
            const elementType = $scope.elementTypes.find((value) => value.value === techElement.type);

            if (unit) {
              techElement.displayUnit = unit.displayName;
            } else {
              techElement.displayUnit = '';
            }

            if (elementType) {
              techElement.displayType = elementType.displayName;
            } else {
              techElement.displayType = '';
            }
          });
        });
      });
    }

    $scope.hasActiveTechSubModules = function (techModule) {
      let activeTechSubModules = false;
      techModule.submodules.forEach(function (techSubModule) {
        if (techSubModule.active === true) {
          activeTechSubModules = true;
        }
      });
      return activeTechSubModules;
    };

    $scope.hasActiveTechElements = function (techSubModule) {
      let activeTechElements = false;
      techSubModule.elements.forEach(function (techElement) {
        if (techElement.active === true) {
          activeTechElements = true;
        }
      });
      return activeTechElements;
    };

    $scope.onToggleCollapse = function (element) {
      element.isCollapsed = !element.isCollapsed;
      $log.debug(element);
    };

    $scope.openEditModuleModal = function (ev, techModule) {
      TechElementModuleService.open(ev, techModule).then(update);
    };

    $scope.openEditSubmoduleModal = function (ev, techSubmodule) {
      TechElementSubmoduleService.open(ev, techSubmodule).then(update);
    };

    $scope.confirmDeleteTechElement = function (ev, techElement, moduleId, submoduleId) {
      let options = {
        title: Labels.getLabel('deletespecificationtitle'),
        content: Labels.getLabel('areyousuredeletespecification') + ' ' + Labels.getLabel('deletespecificationfromdatabase'),
        warning: Labels.getLabel('thisactioncannotbeundone'),
        ok: Labels.getPlural('delete'),
        ok_icon: 'delete',
        cancel: Labels.getLabel('cancel')
      };
      SimpleDialogFormService.confirm(ev, options, techElement)
        .then(() => removeTechElement(techElement, moduleId, submoduleId)).catch(() => {
        });
    };

    $scope.confirmDeleteModule = function (ev, techModule) {
      TechElementModuleService.confirmDelete(ev, techModule).then(update).catch(() => {
      });
    };

    $scope.confirmDeleteSubmodule = function (ev, techSubmodule) {
      TechElementSubmoduleService.confirmDelete(ev, techSubmodule).then(update).catch(() => {
      });
    };

    $scope.openTechElementModal = openTechElementModal;

    //
    // init
    //

    setUnitsAndTypes();

    // functions
    function openTechElementModal (ev, optionalTechElement) {
      $mdDialog.show({
        scope: $scope.$new(),
        preserveScope: false,
        controller: 'TechElementDetailsCtrl',
        controllerAs: '$TechElementDetailsCtrl',
        bindToController: true,
        locals: {
          technicalElements: technicalElements,
          model: optionalTechElement
        },
        templateUrl: 'app-legacy/tech-element/details/tech-element-details.tmpl.html',
        targetEvent: ev
      }).then((result) => {
        update(result);
      }).catch(() => {
      });
    }

    function removeTechElement (techElement, moduleId, submoduleId) {
      techElement.active = false;
      techElement.submodule = {_id: submoduleId};
      techElement.module = {_id: moduleId};
      const updatedElement = {id: techElement._id, element: techElement};
      TechnicalElementsAPI.updateElement(updatedElement).$promise.then(update);
    };

    function update (modules = technicalElements) {
      $scope.modules = modules;
      setUnitsAndTypes();
    }

  }

})();
